import { Component, OnInit } from '@angular/core';
import {FirebaseListObservable, AngularFireDatabase} from "angularfire2/database-deprecated";

@Component({
  selector: 'app-home-component',
  templateUrl: 'home-component.component.html',
  styleUrls: ['home-component.component.scss']
})
export class HomeComponentComponent implements OnInit {

  madhansData: FirebaseListObservable<any>;
  skills: FirebaseListObservable<any[]>;
  organizations: FirebaseListObservable<any[]>;

  items: FirebaseListObservable<any[]>;

  constructor(db: AngularFireDatabase) {

    this.madhansData = db.list('/madhansdata');

    this.organizations = db.list('/madhansdata/organizations');
    this.skills = db.list('/madhansdata/skills');
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/components/home-component/home-component.component.ts